module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp/img_webinar_07_sp-feb5671730a046f60def558a502e1a6e.png";